import type { AppDispatch, RootState } from "@/core/root-reducer"
import { Role } from "./role.types"
import { roleActions } from "./role.reducers"

export const roleFetch = (retry = false) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { _session: session, roles } = getState()
  if (!session.accountId || session.userRole !== "ADMIN" || !session.accountOptions.roleManagementEnabled) return
  if (roles.accountId === session.accountId && (roles.status === "loading" || roles.status === "loaded" || (roles.status === "error" && !retry))) return
  const accountId = session.accountId
  const requestId = crypto.randomUUID()
  dispatch(roleActions.loading({ accountId, requestId }))
  const response: any = await dispatch({ type: "API", payload: { method: "GET", url: "/roles" } })
  if (response.error || !Array.isArray(response)) {
    dispatch(roleActions.failed({ requestId }))
  } else {
    dispatch(roleActions.loaded({ accountId, requestId, list: response.map((role) => new Role(role)) }))
  }
}

export const roleSave = (role: Role, isNew: boolean) => persistRole(role, isNew, { name: role.name })

export const roleUpdateRules = (role: Role, changes: Partial<Pick<Role, "conditions" | "scopeFilterNames" | "scopePopulations">>) =>
  persistRole(role, false, changes)

const persistRole = (role: Role, isNew: boolean, changes: Partial<Pick<Role, "name" | "conditions" | "scopeFilterNames" | "scopePopulations">>) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { _session: session, roles } = getState()
  const accountId = session.accountId
  if (role.AccountId !== accountId || roles.accountId !== accountId || roles.status !== "loaded") return false
  const requestId = roles.requestId
  const response: any = await dispatch({
    type: "API",
    payload: {
      method: isNew ? "POST" : "PATCH",
      url: isNew ? "/roles" : `/roles/${role.id}`,
      data: changes
    }
  })
  if (response.error || getState().roles.requestId !== requestId || getState()._session.accountId !== accountId) return false
  dispatch(roleActions.saved({ accountId, requestId, role: new Role(response) }))
  return response.id as string
}

// Membres du rôle : résolus côté serveur à partir des conditions, jamais stockés.
export const roleFetchUsers = (roleId: string, search: string, limit: number, offset: number) => ({
  type: "API",
  payload: {
    method: "GET",
    url: `/roles/${roleId}/users`,
    data: { search, limit, offset }
  }
})

export const roleDestroy = (role: Role) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { _session: session, roles } = getState()
  const accountId = session.accountId
  if (role.AccountId !== accountId || roles.accountId !== accountId || roles.status !== "loaded") return false
  const requestId = roles.requestId
  const response: any = await dispatch({ type: "API", payload: { method: "DELETE", url: `/roles/${role.id}` } })
  if (response?.error || getState().roles.requestId !== requestId || getState()._session.accountId !== accountId) return false
  dispatch(roleActions.removed({ accountId, requestId, id: role.id }))
  return true
}
